import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-data-source',
  templateUrl: './help-add-data-source.component.html',
  styleUrls: ['./help-add-data-source.component.scss']
})
export class HelpAddDataSourceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
